import { useMemo } from "react";
import { useStoryCostEvents } from "@/hooks/useStoryCostEvents";
import { computeCostPerItem, type CostPerItemResult } from "@/lib/costPerItem";

export interface CostPerItemState {
  result: CostPerItemResult;
  loading: boolean;
  error: string | null;
  planGated: boolean;
}

export function useCostPerItem(enabled = true): CostPerItemState {
  const { events, loading, error, planGated } = useStoryCostEvents();
  const result = useMemo(() => computeCostPerItem(events), [events]);

  if (!enabled) {
    return {
      result: computeCostPerItem([]),
      loading: false,
      error: null,
      planGated: false,
    };
  }

  return { result, loading, error, planGated };
}
